import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { SiteService } from "../../services/site";
import { showErrorResponse } from "../../varibles/global";
import { IFishGroup, ISite } from "../../varibles/interface";
import { siteActions } from "./reducer";


function* getsWatcher(): Generator {
    try {
        const data = yield call(SiteService.gets);
        yield put(siteActions.getsSuccess(data as ISite[]));
    } catch (error) {
        yield put(siteActions.getsFailure())
        showErrorResponse('Get sites failure', error);
    }
}

function* getOverviewWatcher(action: PayloadAction<string | undefined>): Generator {
    try {
        const data = yield call(SiteService.overview);
        const mode = action.payload || "unit";
        if (mode === "unit") {
            yield put(siteActions.getOverviewSuccess(data as ISite[]));
        } else {
            yield put(siteActions.updateDashboard(data as ISite[]));
        }
    } catch (error) {
        yield put(siteActions.getOverviewFailure())
        showErrorResponse('Get sites failure', error);
    }
}


function* getFishGroupWatcher(): Generator {
    try {
        const data = yield call(SiteService.fishGroup);
        yield put(siteActions.getFishGroupSuccess(data as IFishGroup[]));
    } catch (error) {
        yield put(siteActions.getFishGroupFailure())
        showErrorResponse('Get fish group failure', error);
    }
}

export default function* locationSaga() {
    yield all([
        takeEvery(siteActions.gets.type, getsWatcher),
        takeEvery(siteActions.getOverview.type, getOverviewWatcher),
        takeEvery(siteActions.getFishGroup.type, getFishGroupWatcher),
    ])
}
